import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface ServiceProviderAvailabilitiesDialogProps {
    open: boolean;
    organizationId: string;
    serviceProviderId: string;
    serviceProviderName: string;
}

const initialState: ServiceProviderAvailabilitiesDialogProps = { open: false, organizationId: "", serviceProviderId: '', serviceProviderName: '' };

const serviceProviderAvailabilitiesDialogSlice = createSlice({
    name: 'serviceProviderAvailabilitiesDialog',
    initialState,
    reducers: {
        openServiceProviderAvailabilitiesDialog: (state, action: PayloadAction<{ organizationId: string; serviceProviderId: string; serviceProviderName: string; }>) => {
            state.open = true;
            state.organizationId = action.payload.organizationId;
            state.serviceProviderId = action.payload.serviceProviderId;
            state.serviceProviderName = action.payload.serviceProviderName;
        },
        closeServiceProviderAvailabilitiesDialog: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { openServiceProviderAvailabilitiesDialog, closeServiceProviderAvailabilitiesDialog, } = serviceProviderAvailabilitiesDialogSlice.actions;
export default serviceProviderAvailabilitiesDialogSlice.reducer;
export const selectServiceProviderAvailabilitiesDialog = (state: RootState) => state.serviceProviderAvailabilitiesDialog;